import * as React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { usePunchCards } from "../../../service/api";
import { routes } from "../../../appRoutingHelpers";
import * as authSelectors from "../../auth/authSelectors";
import { PageHeader } from "../../common/PageHeader";
import { ProductPackRow } from "./PunchCardRow";
import Spinner from "../../common/Spinner";
import { useHandleFetchError } from "../../../error-handler";

export const PunchCardsList: React.FC = () => {
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);
  const {
    data: punchCards,
    isLoading: punchCardsLoading,
    error: punchCardsError,
  } = usePunchCards(organization);

  useHandleFetchError(punchCardsError);

  if (!punchCards || punchCardsLoading) {
    return (
      <div className="card-footer text-center">
        {punchCardsLoading && <Spinner />}
      </div>
    );
  }

  return (
    <>
      <div className="container">
        <PageHeader
          title="Punch Cards List"
          breadcrumbs={[
            { title: "Punch Cards List" },
            { title: "Overview", isActive: true },
          ]}
        />
      </div>

      <div className="container">
        <div className="row row-cards row-deck">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">Punch Cards List</h3>
                <div className="card-options">
                  <Link
                    className="btn btn-primary btn-sm"
                    to={routes.punchCardsNew(organization)}
                  >
                    Add new
                  </Link>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-hover table-outline table-vcenter card-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th># of products</th>
                      <th className="w-1"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {punchCards.map((punchCard) => (
                      <ProductPackRow
                        key={punchCard.id}
                        punchCard={punchCard}
                        organization={organization}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PunchCardsList;
